import { ILogEvent } from "../../types";
import { useSelector, useStore } from "react-redux";
import { offlineSelector } from "../../../redux/metadata/selectors/metadata.selectors";
import Dayjs from "../../dayjs";
import OfflineStorage from "../../offlineStorage/OfflineStorage";
import { BADGE_EVENTS, ReasonCodes } from "../../enums";
import PublicApiService from "../../../services/PublicApiService";
import { RootState } from "../../../redux/store";

export const useLogEvent = () => {
  const offline = useSelector(offlineSelector);
  const { getState } = useStore();

  const logEvent = async (event: Omit<ILogEvent["event"], "eventDate">, deviceId?: string) => {
    const eventDate = Dayjs(new Date()).utc().format();
    const eventToSend: ILogEvent["event"] = { ...event, eventDate };

    if (
      !event.badgeId &&
      event.reasonCode !== ReasonCodes.UnableToDecryptBadge &&
      event.reasonCode !== ReasonCodes.FaultyQrCode &&
      event.reasonCode !== ReasonCodes.BadgeNotFound
    ) {
      return;
    }
    if (offline) {
      await OfflineStorage.addLogEvent({ type: BADGE_EVENTS.DOWNLOAD, event: eventToSend });
      return;
    }
    try {
      const gbsCode = (getState() as RootState).eventEdition.eventEdition!.gbsCode;
      await PublicApiService.logBadgeDownloadedEvent([eventToSend], gbsCode, deviceId);
    } catch (e) {
      console.warn(e);
    }
  };

  return { logEvent };
};
